import { useEffect, useState } from "react";
import { Button } from "antd";
import { IHistoryItem } from "../../../../../network/models/HistoryType";
import styles from "./index.module.scss";

let initSelectItems = ["已解决", "未解决"];

interface IProps {
  items?: string[];
  currentItem: IHistoryItem | undefined;
  onCancel: () => void;
  onSuccess: (result) => void;
}
export default function ReviseFrame({
  items,
  currentItem,
  onCancel,
  onSuccess,
}: IProps) {
  const initSelected = currentItem === undefined ? "" : currentItem.tagName;
  const [selectItems] = useState<string[]>(items || initSelectItems);
  const [selected, setSelected] = useState<string>(initSelected);

  const options = selectItems.map((item) => {
    return (
      <div key={item}>
        <div
          className={[
            styles.selectIcon,
            item === selected ? styles.hasSelected : styles.noSelected,
          ].join("  ")}
          onClick={() => setSelected(item)}
        ></div>
        <span>{item}</span>
      </div>
    );
  });

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2>是否已帮助客户解决问题？</h2>
        </div>
        <div className={styles.modalBody}>
          <p className={styles.tips}>您仅有一次修改机会</p>
          <div className={styles.selectWrapper}>{options}</div>
        </div>
        <div className={styles.modalFooter}>
          <Button onClick={() => onCancel()}>取消</Button>
          <Button
            type="primary"
            disabled={selected === currentItem?.tagName}
            onClick={() => onSuccess(selected)}
          >
            确认
          </Button>
        </div>
      </div>
    </div>
  );
}
